<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="warehouseLocationAdministration commonListStyles">
            <van-overlay :show="loadingShow">
                <van-loading vertical type="spinner" color="#fff">
                    {{ loadingText }}
                </van-loading>
            </van-overlay>
            <HeaderNav
                header-title="库位管理"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: swiperright, rightCallBack: addWarehouseLocation, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">库位编号：{{ item.grid_code }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>库位名称：{{ item.grid_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_18@2x.png" alt="">
                                            <span>库位号：{{ item.grid_no }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>物料代码：{{ item.material_codes }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料短描述：{{ item.material_short_names }} </span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_4@2x.png" alt="">
                                            <span>所属仓库：{{ item.stock_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>库位类别：{{ item.grid_category_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>当前库存：{{ item.current_volume }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button @click="openWarehouseLocation(item)">
                                            维护
                                        </van-button>
                                        <van-button @click="printLabel(item)">
                                            打印标签
                                        </van-button>
                                        <van-button :disabled="item.current_volume > 0" @click="deleteStorageLocation(item)">
                                            删除
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <van-action-sheet
                v-model="showPrinterList"
                cancel-text="取消"
                description="选择打印机"
                close-on-click-action
                :actions="printerList"
                @select="selectPrinter"
            ></van-action-sheet>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
import { LPAPI } from '@/assets/js/print/LPAPI-0.4.20181022.js';
export default {
    name: 'warehouse-location-administration',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'warehouse-location-administration');
        }
        next();
    },
    data() {
        return {
            loadingShow: false,
            loadingText: '',
            tableCode: 'stock_grid_list',
            lpapi: null,
            showPrinterList: false,
            printerList: [],
            printerData: {},
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        this.lpapi = new LPAPI();
        window.callback_DzLPAPI_scanPrinters = this.callback_DzLPAPI_scanPrinters;
        window.callback_DzLPAPI_openPrinter = this.callback_DzLPAPI_openPrinter;
        window.callback_DzLPAPI_isPrinterOpened = this.callback_DzLPAPI_isPrinterOpened;
        this.loadLPAPI();
    },
    mounted() {},
    methods: {
        loadLPAPI() {
            this.lpapi.reopenPrinter();
        },
        addWarehouseLocation() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'warehouseLocationForm', params: { type: 'new' } });
        },

        // 打开库位详情
        openWarehouseLocation(item) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'warehouseLocationForm', params: { type: 'maintenance', data: item } });
        },

        printLabel(item) {
            this.printerData = item;
            if (this.$detectOS() === 'ios') {
                this.$callMobile('DzLPAPI', 'isPrinterOpened', {});
                this.loadingText = '打印中...';
                this.loadingShow = true;
            } else if (this.$detectOS() === 'Android') {
                if (this.lpapi.isPrinterOpened === true) {
                    this.loadPrintText_Android();
                } else {
                    const printerNames = this.lpapi.getAllPrinters();
                    if (!printerNames) {
                        this.$toast.fail('未检测到打印机');
                        return;
                    }
                    this.printerList = (printerNames.split(',') || []).map(k => { return { name: k };});
                    this.showPrinterList = true;
                }
            }
        },

        callback_DzLPAPI_isPrinterOpened(res) {
            this.loadingShow = false;
            if (res === 'true') {
                this.loadPrintText_ios();
            } else {
                this.$callMobile('DzLPAPI', 'scanPrinters', {});
                this.loadingText = '搜寻打印机中...';
                this.loadingShow = true;
            }
        },

        // ios打印机列表回调
        callback_DzLPAPI_scanPrinters(printerNames) {
            this.loadingShow = false;
            if (!printerNames) {
                this.$toast.fail('未检测到打印机');
                return;
            }
            this.printerList = (printerNames.split(',') || []).map(k => { return { name: k };});
            this.showPrinterList = true;
        },

        selectPrinter(item) {
            if (this.$detectOS() === 'ios') {
                this.$callMobile('DzLPAPI', 'openPrinter', { printerName: item.name });
                this.loadingText = '链接打印机中...';
                this.loadingShow = true;
            } else if (this.$detectOS() === 'Android') {
                const type = this.lpapi.openPrinterSync(item.name);
                if (type) {
                    this.loadPrintText_Android();
                } else {
                    this.$toast.fail('打印机链接失败！');
                }
            }
            this.showPrinterList = false;
        },

        callback_DzLPAPI_openPrinter(res) {
            this.loadingShow = false;
            if (res === 'true') {
                this.loadPrintText_ios();
            } else {
                this.$toast.fail('打印机链接失败！');
            }
        },

        loadPrintText_Android() {
            const grid_code = `"${JSON.stringify({ grid_code: this.printerData.grid_code })}"`;
            this.lpapi.startJob(70, 40, 90);
            this.lpapi.drawRectangle(1, 2, 66, 36, 0.3);
            this.lpapi.drawText('仓库名称', 2, 3.5, 16, 7, 3, 0);
            this.lpapi.drawText(this.printerData.stock_name, 17, 3.5, 27, 7, 3, 0);
            this.lpapi.drawLine(1, 9, 45, 9, 0.3);
            this.lpapi.drawText('库位名称', 2, 10.5, 16, 7, 3, 0);
            this.lpapi.drawText(this.printerData.grid_name, 17, 10.5, 27, 7, 3, 0);
            this.lpapi.drawLine(1, 16, 45, 16, 0.3);
            this.lpapi.drawText('库位号', 2, 17.5, 16, 7, 3, 0);
            this.lpapi.drawText(this.printerData.grid_no, 17, 17.5, 27, 7, 3, 0);
            this.lpapi.drawLine(1, 23, 45, 23, 0.3);
            this.lpapi.drawText('物料代码', 2, 24.5, 16, 7, 3, 0);
            this.lpapi.drawText(this.printerData.material_codes, 17, 24.5, 27, 7, 3, 0);
            this.lpapi.drawLine(1, 30, 67, 30, 0.3);
            this.lpapi.drawText('短描述', 2, 32, 16, 7, 3, 0);
            this.lpapi.drawText(this.printerData.material_short_names, 17, 32, 48, 7, 3, 0);
            this.lpapi.drawLine(15, 2, 15, 38, 0.3);
            this.lpapi.drawLine(45, 2, 45, 30, 0.3);
            this.lpapi.draw2DQRCode(grid_code, 46.5, 7, 18, 18);
            this.lpapi.commitJob();
        },

        loadPrintText_ios() {
            const grid_code = `"${JSON.stringify({ grid_code: this.printerData.grid_code })}"`;
            this.$callMobile('DzLPAPI', 'startDraw', { width: 70, height: 40, orientation: 90 });
            this.$callMobile('DzLPAPI', 'drawRectangleWithX', { x: 1, y: 2, width: 66, height: 36, lineWidth: 0.3, isFilled: 0 });
            this.$callMobile('DzLPAPI', 'drawText', { text: '仓库名称', x: 2, y: 3.5, width: 16, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: this.printerData.stock_name, x: 17, y: 3.5, width: 25, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawLine', { x: 1, y: 9, width: 43, height: 0.3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: '库位名称', x: 2, y: 10.5, width: 16, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: this.printerData.grid_name, x: 17, y: 10.5, width: 25, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawLine', { x: 1, y: 16, width: 43, height: 0.3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: '库位号', x: 2, y: 17.5, width: 16, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: this.printerData.grid_no, x: 17, y: 17.5, width: 25, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawLine', { x: 1, y: 23, width: 43, height: 0.3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: '物料代码', x: 2, y: 24.5, width: 16, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: this.printerData.material_codes, x: 17, y: 24.5, width: 27, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawLine', { x: 1, y: 30, width: 66, height: 0.3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: '短描述', x: 2, y: 32, width: 16, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawText', { text: this.printerData.material_short_names, x: 17, y: 32, width: 48, height: 7, fontHeight: 3 });
            this.$callMobile('DzLPAPI', 'drawLine', { x: 15, y: 2, width: 0.3, height: 36 });
            this.$callMobile('DzLPAPI', 'drawLine', { x: 44, y: 2, width: 0.3, height: 28 });
            this.$callMobile('DzLPAPI', 'drawQRCode', { text: grid_code, x: 46.5, y: 7, width: 18 });
            this.$callMobile('DzLPAPI', 'endDraw', {});
            this.$callMobile('DzLPAPI', 'print', {});
        },

        async deleteStorageLocation(item) {
            const res = await this.deleteWarehouseLocationRequrst(item.id);
            if (res) {
                this.$toast.success('删除成功。');
                this.onRefresh();
            }
        },

        // 删除库位
        deleteWarehouseLocationRequrst(id) {
            return this.$axios.$delete(`/interfaceApi/procurement/stock_grid/delete/${id}`);
        },
    },
};
</script>
<style lang="stylus">
.warehouseLocationAdministration
    .van-loading
        position absolute
        top 50%
        left 50%
        z-index 9
        transform translate(-50% , -50%)
</style>
